/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
var sorted_json = [];

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Terms overlay
        $('i.glyphicon-remove').click(function(e) {
          $('div#terms-overlay').fadeOut('slow');
        });

        $('a#tc').click(function(e) {
          e.preventDefault();
          $('div#terms-overlay').fadeIn('slow');
        });
        /* ========================================================================
         * Vars
         * ======================================================================== */

        var $grid = null;


        /* ========================================================================
         * Bootstrap Media Queries Environment
         * ======================================================================== */

        function findBootstrapEnvironment() {
          var envs = ['xs', 'sm', 'md', 'lg'];

          var $el = $('<div>');
          $el.appendTo($('body'));

          for (var i = envs.length - 1; i >= 0; i--) {
            var env = envs[i];

            $el.addClass('hidden-'+env);
            if ($el.is(':hidden')) {
              $el.remove();
              return env;
            }
          }
        }
        var bootstrap_environment = findBootstrapEnvironment();
        var bootstrap_prev_environment = null;


        /* ========================================================================
         * Menu trigger
         * ======================================================================== */

        $('.icon-bars').click(function(){
          $(this).next().slideToggle('fast');
        });


        /* ========================================================================
         * Carousel
         * ======================================================================== */

        $('body div.slideshow').owlCarousel({
          //navText: ['<span class="icon-left-open-big"></span>', '<span class="icon-right-open-big"></span>'],
          navText: ['', ''],
          loop: true,
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          nav: false,
          dots: true,
          dotClass: 'icon-diamond',
          //dotsData: false,
          items: 1
        });


        /* ========================================================================
         * Masonry
         * ======================================================================== */

        function initiate_masonry() {
          // Do not use on xs, because we only use one column boxes
          if (bootstrap_environment !== 'xs') {
            $grid = $('.grid').masonry({
              itemSelector: '.grid-item',
              columnWidth: '.grid-sizer',
              percentPosition: true
            });

            //console.log('masonry init');
          }
        }

        initiate_masonry();


        function destroy_masonry() {
          $grid.masonry('destroy');
          //console.log('masonry destroy');
        }


        /* ========================================================================
         * Linked box
         * ======================================================================== */

        $('div.linked').on('click', function (e) {
          var $children_link = $(this).find('a:last');
          if ($children_link.length === 1) {
            e.preventDefault();
            window.location = $children_link.attr('href');
          }
        });

        $('div.linked').on('click', function (e) {
          var $children_link = $(this).find('a:last');
          if ($children_link.length === 1) {
            e.preventDefault();
            window.location = $children_link.attr('href');
          }
        });


        /* ========================================================================
         * Chosen
         * ======================================================================== */

        if ($('select').length) {
          $('select').chosen({});
        }


        /* ========================================================================
         * Newsletter AJAX
         * ======================================================================== */

        $('form.newsletter').submit(function(e) {
          e.preventDefault();

          var email = $(this).find('input.email').val();

          if (email.indexOf('@') > 0) {
            var that = this;

            request = $.ajax({
              data: { action: 'newsletter-registration', email: email },
              url: '/ajax',
              type: "POST",
              dataType: "json"
            });

            request.success(function(result) {
              if (result !== '0') {
                if (result.success === true) {
                  $(that).slideUp('fast');

                }
                $(that).next().show().text(result.message);
              }
            });

          }

        });


        /* ========================================================================
         * Product nav
         * ======================================================================== */

        // Recursive function for finding all the parents
        function show_parents(parent_id) {
          $obj = $('a[data-id="' + parent_id + '"]');
          if ($obj) {

            $ul = $obj.parentsUntil('ul.sub-nav').parent();

            if ($ul.hasClass('sub-nav')) {
              //console.log('find_parents: ' + $obj.attr('data-parent-id'));
              $ul.show();
              show_parents($obj.attr('data-parent-id'));
            }
          }
        }

        $('nav#cat-nav ul > li > a').click(function(e) {
          var id = $(this).attr('data-id');
          var parent_id = $(this).attr('data-parent-id');
          var selector = 'nav#cat-nav ul#sub-' + id;
          var $target = $(selector);
          var has_dropdown = ($target.length > 0);
          if (has_dropdown === true) {
            if($(this).parents().hasClass('parent-nav')){
              e.preventDefault();
            }

            if($(this).parents().hasClass('active')){
              $('nav#cat-nav ul.sub-nav active').show();
              e.preventDefault();
            }
            // Hide all subs
            $('nav#cat-nav ul.sub-nav').hide();

            // //Show Children of selected
            // $('nav#cat-nav ul.sub-nav active').show();

            // Show child div (with this parent id)
            $target.show();

            // Calc all the parents and show them.
            if (parent_id !== undefined) {
              show_parents(id);
            }
          }
        });

        $('body').on('click', 'a.next', function(e){
          e.preventDefault();
          var href = $(this).attr('href');
          $('.products').addClass('loading-shade');
          $('.berocket_aapf_widget-wrapper').addClass('loading-shade');
          $.get(href).success(function(data) {
            var $data = $(data);
            var next = $data.find('a.next');
            var current = $data.find('noscript.current');
            var products = $data.find('.products li');
            
            if (products.length) {
              $('.products').append(products);
              $('a.next').remove();
              $('noscript.current').remove();
              $('.products').append(next);
              $('.products').append(current);
              $('a.next').not('a.next:last').remove();

              if (!next.length) {
                $('a.next').remove();
              }
              $('.loading-shade').removeClass('loading-shade');
              $('.berocket_aapf_widget-wrapper').show();

            }
          });
        });

        $('#cat-nav ul.sub-nav a').on('click', function(e){
          e.preventDefault();
          var href = $(this).attr('href');
          $('.products').addClass('loading-shade');
          $('.berocket_aapf_widget-wrapper').addClass('loading-shade');
          //Reset price-slider
          $('#slider-range').each(function(){
            var options = $(this).slider( 'option' );
            $(this).slider( 'values', [ options.min, options.max ] );
            $(this).prev().find('span').html(options.values[0]);
            $(this).next().find('span').html(options.values[1]);
          });
          
          $.get(href).success(function(data) {
            var $data = $(data);
            var next = $data.find('a.next');
            var current = $data.find('noscript.current');
            var products = $data.find('.products');
            
            if (products.length) {
              $('a.next').remove();
              $('noscript.current').remove();
              $('.products').replaceWith(products);
              $('.products').append(next);
              $('.products').append(current);

              $('.berocket_aapf_widget-wrapper').removeClass('loading-shade');
              $('.berocket_aapf_widget-wrapper').show();

            }else {
              $('.products').empty();
              $('.berocket_aapf_widget-wrapper').hide();
              $('.products').append('<div class="shop-text-center">No products found</div>');
            }
          });
        });

        /* ========================================================================
         * Price Slider
         * ======================================================================== */

        $( function() {
          $( "#slider-range" ).slider({
            range: true,
            min: 1,
            max: 999999,
            values: [ 1, 999999 ],
            stop: function( event, ui ) {

              $('noscript.current').attr("data-current", function() {
                var filter = $(this).attr("data-current");
                return filter.substring(0, filter.lastIndexOf("/") + 1) + "?min_price=" + ui.values[0] + "&max_price=" + ui.values[1] ;
              });

              var href = $('noscript.current').attr("data-current");
              
              $('.products').addClass('loading-shade');
              $('.berocket_aapf_widget-wrapper').addClass('loading-shade');
              $.get(href).success(function(data) {
                var $data = $(data);
                var next = $data.find('a.next');
                var current = $data.find('noscript.current');
                var products = $data.find('.products');
                if (products.length) {
                  $('a.next').remove();
                  $('noscript.current').remove();
                  $('.products').replaceWith(products);
                  $('.products').append(next);
                  $('.products').append(current);
                  $('.berocket_aapf_widget-wrapper').removeClass('loading-shade');
                  $('.berocket_aapf_widget-wrapper').show();
    
                }else {
                  $('.products').empty();
                  $('.berocket_aapf_widget-wrapper').hide();
                  $('.products').append('<div class="shop-text-center">No products found</div>');
                }
              });
            }
          });
          $("#amount").val( $("#slider-range").slider("values", 0) + "kr - " + $("#slider-range").slider("values", 1) + "kr");
        });


        $(".price-slider").on("slidecreate", function(event, ui) {
          $(this).before('<div class="left-price custom-price"><span>' + $("#slider-range").slider("values", 0) + '</span> ' + sorsand_i18n.curr + '</div>');
          $(this).after('<div class="right-price custom-price"><span>' + $("#slider-range").slider("values", 1) + '</span> ' + sorsand_i18n.curr + '</div>');
        } );

        $(".price-slider").on("slide", function(event, ui) {
          $(this).prev().find('span').html(ui.values[0]);
          $(this).next().find('span').html(ui.values[1]);
        });

        
        /* ========================================================================
         * Product image change
         * ======================================================================== */

        $('main.main').on('click', '#small-image',
          function(e) {
            var srcset = $(this).find('img').attr('data-src');
            e.preventDefault();
            $('main.main').find('.main-image').attr('srcset', srcset);
          }
        );

        /* ========================================================================
         * Product content hover
         * ======================================================================== */

        // active. hover
        $('main.main').on('mouseenter', 'ul.products li div.product-container',
          function() {
            $(this).find('.product-bg').addClass('active');
            $(this).find('.product-image-secondary').addClass('active');
          }
          )

          .on('mouseleave', 'ul.products li div.product-container',
            function() {
              $(this).find('.product-bg').removeClass('active');
              $(this).find('.product-image-secondary').removeClass('active');
            }
          )

          // click
          .on('click', 'ul.products li div.product-container',
            function(e) {
              e.preventDefault();
              document.location.href = $(this).find('a:first').attr('href');

            }
          )
        ;

        /* ========================================================================
         * Engraving select
         * ======================================================================== */


        $('body.single.product select#pa_' + engraving_id).change(function(e) {   // engraving_id is global, set by PHP function wc_product_addon_inline_scripts().
          var index = $('select#pa_' + engraving_id + ' option:selected').index();

          // Show or hide engraving text
          if (index > 1) {
            $('.product-addon').show();
          } else {
            $('.product-addon').hide();
          }
        });

        /* ========================================================================
         * Bootstrap Media Queries: Fix various things on resize
         * ======================================================================== */

        function bootstrap_threshold_trigger() {

          //console.log('bootstrap_threshold_trigger');

          if ($('select').length) {
            $('select').chosen('destroy');
            $('select').chosen({});
          }

          // Fix masonry: Destroy if trigger is to mobile, initiate if trigger is from mobile
          if (bootstrap_environment === 'xs') {
            destroy_masonry();
          }

          if (bootstrap_prev_environment === 'xs') {
            initiate_masonry();
          }
        }

        /* ========================================================================
         * Bootstrap Media Queries: Check if a threshold is triggered on resize
         * ======================================================================== */

        $(window).resize(function() {
          if (bootstrap_environment !== findBootstrapEnvironment()) {
            bootstrap_prev_environment = bootstrap_environment;
            bootstrap_environment = findBootstrapEnvironment();
            bootstrap_threshold_trigger();
          }
        });

        /* ========================================================================
         * Retailer, map
         * ======================================================================== */

        var markers = [];
        var map;
        var json_data;
        var allowListener = false;

        function format_retailer_html(post) {
          var html = '';

          // Company
          if (post.title !== '') {
            html += '<strong>' + post.title + '</strong><br />';
          }

          // Name
          //if (post.name !== '') {
          //  html += post.name + '<br />';
          //}

          // Address
          if (post.address !== '') {
            html += post.address + '<br />';
          }

          // Zip and city
          if (post.zip !== '' && post.city !== '') {
            html += post.zip + ' ' + post.city + '<br />';
          } else {
            if (post.zip !== '') {
              html += post.zip + '<br />';
            }
            if (post.city !== '') {
              html += post.city + '<br />';
            }
          }

          // Tel
          if (post.tel !== '') {
            html += 'Tel: ' + post.tel + '<br />';
          }

          // Mob
          if (post.mob !== '') {
            html += 'Mob: ' + post.mob + '<br />';
          }

          // Fax
          if (post.fax !== '') {
            html += 'Fax: ' + post.fax + '<br />';
          }

          // Email
          if (post.email !== '') {
            html += '<a href="mailto:' + post.email + '">' + post.email + '</a><br />';
          }

          // WWW
          if (post.web !== '') {
            var url = post.web;
            //if (url.indexOf('://') === -1) {
            //  url = 'http://' + url;
            //}
            html += '<a href="' + url + '" target="_blank">' + post.web + '</a>';
          }

          return html;
        }

        function checkBoundsForMarkers() {
          //var shown_markers = '';
          //$.each(json_data, function(index, c) {
          //console.log(c);
          //var latlng = new google.maps.LatLng(c.lat,c.lng);
          //if (map.getBounds().contains(latlng)) {
          //console.log(c);
          //shown_markers += '<li>' + format_retailer_html(c) + '</li>';
          //}
          //});

          //shown_markers = (shown_markers.length) ? '<ul id="saljkontor-list">' + shown_markers + '</ul>' : json_data.no_posts;
          //$('#saljkontor-list-container').html(shown_markers);
        }

        function addMarkers(data) {
          setMapOnAll(null);
          json_data = data;

          var bounds = new google.maps.LatLngBounds();
          markers = [];

          // Loopa igenom json
          $.each(json_data, function(index, group) {
            $.each(group, function(index, c) {

              var marker;
              var latlng = new google.maps.LatLng(c.lat,c.lng);
              marker = new google.maps.Marker({
                map: map,
                position: latlng,
                title: c.title,
                icon: '/a/images/pin.png'

              });

              markers.push(marker);

              var infowindow = new google.maps.InfoWindow();
              google.maps.event.addListener(marker, 'click', function() {
                var html = format_retailer_html(c);
                infowindow.setContent(html);
                infowindow.open(map, this);

              });

              bounds.extend(latlng);

              //google.maps.event.addListener(marker, 'click', function() {
              //  window.location.href = c.url;
              //});


              //var gMarker = new google.maps.Marker(marker);
              //
              //marker.gMarker = gMarker;
              //
              //gMarker.setVisible(true); // show init?
              //
              //gMarker.markerData = marker;


            }); // each
          }); // each

          map.fitBounds(bounds);
          if (markers.length === 1) {
            map.setZoom(14);
          }

          //console.log('refresh map, markers count: ' + markers.length);

          //mcOptions = {
          //  styles:
          //    [
          //      {
          //        url: 'https://googlemaps.github.io/js-marker-clusterer/images/pin.png',
          //        height: 58,
          //        width: 30,
          //        anchor: [10, 0],
          //        textColor: '#ffffff',
          //        textSize: 10,
          //        iconAnchor: [25, 48]
          //      }
          //    ]
          //};
          //
          //markerClusterer = new MarkerClusterer(map, markers, mcOptions);
          //}
        }

        // Sets the map on all markers in the array.
        function setMapOnAll(map) {
          for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(map);
          }
        }


        function checkBoundsAndMaybeZoomOut() {

          if (allowListener === true) {

            //console.log('Zoom lvl:' + map.getZoom());

            var bounds = map.getBounds();
            var count = 0;

            for (var i = 0; i < markers.length; i++) {
              var marker = markers[i];

              if(bounds.contains(marker.getPosition()) === true) {
                count++;
              }
            }

            //console.log('count: ' + count);

            if (count > 0) {
              allowListener = false;
            } else {
              map.setZoom(map.getZoom() - 1);
              //console.log('Changed Zoom lvl:' + map.getZoom());
            }

            //console.log('Marker count:' + count);
          }
        }

        function refreshMap() {
          //if (markerClusterer) {
          //  markerClusterer.clearMarkers();
          //}


          //console.log('inline_posts.length');
          addMarkers(inline_posts);

          allowListener = true;
          checkBoundsAndMaybeZoomOut();

        }

        function initialize()
        {

          //var is_touch = Modernizr.touch;
          //var styles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]}];
          var styles = [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"on"},{"saturation":-100},{"lightness":20}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"on"},{"saturation":-100},{"lightness":40}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"saturation":-90},{"lightness":30}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":-60},{"lightness":10}]},{"featureType":"landscape.natural","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":-60},{"lightness":60}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"},{"saturation":-100},{"lightness":60}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"},{"saturation":-100},{"lightness":60}]}];
          //var styles = [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#D4D9E1"},{"visibility":"on"}]}];
          var myOptions =	{
            zoom: 6,
            center: new google.maps.LatLng(59.31076795603884, 17.9296875),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            streetViewControl: true,
            //panControl: is_touch,
            //draggable: !is_touch,
            styles: styles,
            scrollwheel: false,
          };

          // Disable draggable maps on tablets and phones
          if (bootstrap_environment === 'sm' || bootstrap_environment === 'xs') {
            myOptions.panControl = true;
            myOptions.draggable = false;
          }

          map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);

          // Dra i kartan
          google.maps.event.addListener(map, 'dragend', function() {
            //checkBoundsForMarkers();
          });

          // Zoom ut/in
          google.maps.event.addListener(map, 'zoom_changed', function() {
            //checkBoundsForMarkers();
          });

          //geocoder = new google.maps.Geocoder();
          //
          //if (navigator.geolocation) {
          //  navigator.geolocation.getCurrentPosition(function (position) {
          //    initialLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          //    map.setCenter(initialLocation);
          //    map.setZoom(8);
          //    //console.log(initialLocation);
          //    //checkBoundsForMarkers();
          //  });
          //}

          google.maps.event.addListener(map, 'idle', function() {
            //checkBoundsAndMaybeZoomOut();
          });

          addMarkers(inline_posts);


        }//close initialize

        if ($('#map_canvas').length) {
          google.maps.event.addDomListener(window, 'load', initialize);
        }


        /* ========================================================================
         * Retailer, nav and lists
         * ======================================================================== */

        $('nav.side-nav ul#retailer-nav a').click(function(e) {
          e.preventDefault();

          // Hide everything
          $('div#main-content div.retailer').addClass('hidden');

          // Show chosen city
          $('div#main-content div.retailer#list-' + $(this).text()).removeClass('hidden');

          // Active class on nav
          $('nav.side-nav ul#retailer-nav a').removeClass('active');
          $(this).addClass('active');

          var newMarkers = {'retailer' : inline_posts[$(this).text()]};


          //console.log(newMarkers);
          addMarkers(newMarkers);
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
